import type { CSSProperties } from 'react';
import { formatFigure, phaseColor } from '@/lib/phase';
import type { BudgetSegment } from '@/session/debug';

/**
 * Mouth-close to first response frame, split into the stages we tune. The segments always add up to
 * the total — an unnamed one is time nothing accounted for, which is the interesting kind.
 *
 * Proportion only: `flex-grow` carries the figure so no segment can round to nothing, and the
 * numbers live in the readout underneath where a narrow bar cannot clip them.
 */
export function BudgetBar({ segments }: { segments: BudgetSegment[] }) {
  if (!segments.length) return null;

  return (
    <div className="dbg-budget">
      {segments.map((segment, index) => (
        <span
          key={`${segment.phase}-${index}`}
          title={`${segment.label || 'unaccounted'} · ${formatFigure(segment.ms)}ms`}
          className={segment.phase === 'gap' ? 'dbg-seg dbg-seg-gap' : 'dbg-seg'}
          style={{ '--c': phaseColor(segment.phase), flexGrow: segment.ms } as CSSProperties}
        />
      ))}
    </div>
  );
}
